var e = {
  10001: {
    name: "中国建设银行",
    shortName: "建行",
    logo: "https://p0.meituan.net/wxapp/b4d1ff37184a705d5dffde1a815e68a0740.png",
    payType: "405",
    protocolLink: "https://cube.meituan.com/cube/block/5d3798a552f4/269143/index.html"
  },
  10002: {
    name: "中国工商银行",
    shortName: "工行",
    logo: "https://p1.meituan.net/wxapp/34aacb7e03a82b149c48fc15e37dbe581127.png",
    payType: "307",
    protocolLink: ""
  },
  10003: {
    name: "中国农业银行",
    shortName: "农行",
    logo: "https://p0.meituan.net/wxapp/f7b988294f95cc7f73b4948939d79baf1416.png",
    payType: "404",
    protocolLink: ""
  },
  10004: {
    name: "招商银行",
    shortName: "招行",
    logo: "https://p1.meituan.net/wxapp/0b982291e98098e800220d984882b66b1545.png",
    payType: "308",
    protocolLink: ""
  },
  10005: {
    name: "中国银行",
    shortName: "中行",
    logo: "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:7f55719d/zhonghangIcon.png",
    payType: "402",
    protocolLink: "https://cube.meituan.com/cube/block/e9bb8a076213/299729/index.html"
  },
  10006: {
    name: "交通银行",
    shortName: "交行",
    logo: "https://p0.meituan.net/wxapp/d15b434298dec0c99eafda281e52b1a41195.png",
    payType: "406",
    protocolLink: ""
  },
  10007: {
    name: "中国邮政储蓄银行",
    shortName: "邮储",
    logo: "https://p1.meituan.net/wxapp/5dc6ef87f915fe8fce51440546acdec01085.png",
    payType: "403",
    protocolLink: ""
  },
  10008: {
    name: "兴业银行",
    shortName: "兴业银行",
    logo: "https://p1.meituan.net/wxapp/f0c2ee371614d60f3e221cedc2865df41302.png",
    payType: "997",
    protocolLink: ""
  },
  10009: {
    name: "网商银行",
    shortName: "网商银行",
    logo: "https://p0.meituan.net/wxapp/e0197b0f0566c32e84847f9aaecece811210.png",
    payType: "999",
    protocolLink: ""
  },
  10010: {
    name: "微众银行",
    shortName: "微众银行",
    logo: "https://p1.meituan.net/wxapp/6aa139734cbc07b1d9be85b55672e2ae1763.png",
    payType: "998",
    protocolLink: ""
  }
};
export { e as bankConfig };
